import { formatNumber } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'numberSuffix',
    standalone: false
})
export class NumberSuffixPipe implements PipeTransform {

  transform(value: number | string, ...args: any): string {
    if(typeof value === 'string') value = +value;
    value = Math.floor(value * 100) / 100;
    const replaceFormat = args.length > 0 ? true : false;

    let formatedNumber = '-';
        if (!value && value !== 0) return formatedNumber;
        if (value < 10000) {
            formatedNumber = formatNumber(value, 'en', replaceFormat ? args[0] : '1.0');
        } else if (value < 1000000) {
            formatedNumber = formatNumber(this.cut(value / 1000, 1), 'en', replaceFormat ? args[0] : '1.0-1') + ' K';
        } else if (value < 1000000000) {
            formatedNumber = formatNumber(this.cut(value / 1000000, 2), 'en', replaceFormat ? args[0] : '1.0-2') + ' M';
        } else {
            formatedNumber = formatNumber(this.cut(value / 1000000000, 2), 'en', replaceFormat ? args[0] : '1.0-2') + ' B';
        }
        return formatedNumber
  }

  private cut(value: number, nrOfDecimals: number): number {
    const stringVal = value.toString();
    const searchIndex = stringVal.lastIndexOf('.');
    const substring =
        searchIndex > 0
            ? stringVal.substring(0, searchIndex + nrOfDecimals + 1)
            : stringVal;
    return +substring;
  }
}
